/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Rewind(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M14.468,121.27057,103.67394,63.9239A8,8,0,0,1,116,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L14.468,134.72943A8,8,0,0,1,14.468,121.27057Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M126.468,121.27057,215.67394,63.9239A8,8,0,0,1,228,70.65332V185.34668a8,8,0,0,1-12.32606,6.72942L126.468,134.72943A8,8,0,0,1,126.468,121.27057Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default Rewind;
